export const translations = {
  session: {
    expiredToast: {
      'en-150': 'Your session has expired, please log in again.',
      'sk-SK': 'Vaše prihlásenie vypršalo, prihláste sa znova.'
    },
    expiredAction: {
      'en-150':
        'Action failed - your session has expired. Log in again, your changes were not saved.',
      'sk-SK':
        'Akcia zlyhala - vaše prihlásenie vypršalo. Prihláste sa znova, zmeny neboli uložené.'
    }
  }
}
